import React from 'react';
import { useLocation } from 'react-router-dom';
import { isPreviewExperimentOverrideHost } from '../../utils/experimentOverrideHosts';
import {
  EducationDesignPreview,
  useEducationTheme,
  EducationTheme,
  resolveEducationDesignVariant,
  BOOTCAMP_DESIGN_VARIANTS,
} from '../education/EducationDesignExperiment';
import EducationDesignExperiment from '../education/EducationDesignExperiment';
import CoursePage from './CoursePage';
import CoursePageClarityHome from './CoursePageClarityHome';

/** The canonical Bootcamp has one live page. Archived designs are explicit Dev reviews only. */
export function bootcampPageFor(
  search: string,
  allowPreview: boolean,
  theme: EducationTheme = 'dark',
): React.ReactElement {
  const params = new URLSearchParams(search);
  const bootcampPreview = allowPreview ? params.get('bootcampDesign') : null;
  const educationPreview = allowPreview
    ? resolveEducationDesignVariant(params.get('educationDesign'), BOOTCAMP_DESIGN_VARIANTS)
    : null;
  const namePreview =
    allowPreview && params.get('courseNameVariant') === 'agentic' ? 'agentic' : 'control';
  if (educationPreview && !bootcampPreview) {
    return (
      <EducationDesignExperiment>
        <CoursePage variantKey={namePreview} />
      </EducationDesignExperiment>
    );
  }
  return (
    <div
      className="education-design-experiment"
      data-testid="education-design-experiment"
      data-education-design-variant="control"
      data-education-theme={theme}
      data-education-theme-source="preference"
      data-experiment-active="false"
      data-bootcamp-variant={bootcampPreview === 'test' ? 'test' : 'control'}
    >
      <EducationDesignPreview variant={bootcampPreview ? 'control' : educationPreview || 'control'}>
        {bootcampPreview === 'test' ? (
          <CoursePageClarityHome />
        ) : (
          <CoursePage variantKey={namePreview} />
        )}
      </EducationDesignPreview>
    </div>
  );
}

export default function BootcampPage(): React.ReactElement {
  const location = useLocation();
  const theme = useEducationTheme();
  return bootcampPageFor(location.search, isPreviewExperimentOverrideHost(), theme);
}
